"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var HttpProvider = /*#__PURE__*/function () {
  function HttpProvider(endpoint) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, HttpProvider);

    this.endpoint = endpoint;
    this.fetch = HttpProvider.detectFetch(options.fetch);
  }

  _createClass(HttpProvider, [{
    key: "send",
    value: function send(request, callback) {
      this.fetch(this.endpoint, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        return callback(null, data);
      }).catch(function (err) {
        return callback(err);
      });
    }
  }, {
    key: "connected$",
    get: function get() {
      return new rxjs_1.BehaviorSubject(false);
    }
  }, {
    key: "notification$",
    get: function get() {
      throw new Error('HttpProvider doesn\'t support subscriptions');
    }
  }], [{
    key: "detectFetch",
    value: function detectFetch() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var result;

      if (option) {
        result = option;
      } else {
        result = typeof window !== 'undefined' && typeof window.fetch !== 'undefined' ? window.fetch.bind(window) : null;
      }

      if (!result) {
        new Error('fetch not found. Please use `node-fetch` via options.fetch');
      }

      return result;
    }
  }]);

  return HttpProvider;
}();

exports.HttpProvider = HttpProvider;